import type { TFunction } from "i18next";

export interface QuotaNameInput {
  fiscal_year: number;
  linked_projects: { title: string }[];
}

export const isFilmIncentive = (incentive: string | null | undefined) =>
  incentive === "film_audiovisual";

export function quotaName(
  quota: QuotaNameInput,
  incentive: string | null | undefined,
  t: TFunction,
): string {
  const production = quota.linked_projects[0]?.title;
  return isFilmIncentive(incentive) && production
    ? `${production} ${quota.fiscal_year}`
    : t("quota.year", { year: quota.fiscal_year });
}

/** The quota's name without its year: a film's production, the plain quota word otherwise. */
export function quotaTitle(
  quota: Pick<QuotaNameInput, "linked_projects">,
  incentive: string | null | undefined,
  t: TFunction,
): string {
  const production = quota.linked_projects[0]?.title;
  return isFilmIncentive(incentive) && production ? production : t("quotas.quota");
}
